module.exports = __webpack_public_path__ + "static/media/(V)_MG_5941_-_Cia_Termal_Beachewear_-_Moda_Feminina.b72bb49e.jpg";